import { fansupportPublic } from "../index";


export const getCampaignInNumbers = async () => {
    return fansupportPublic.get('campaign/campaigns-info')
};